module.exports = __webpack_public_path__ + "static/paris-005.thumb-43114475d14f802da8cfc67e03da916c.jpg";